import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Page Header Component for Dashboard Pages
 * Provides consistent header styling across Devis, Factures, mes-dossiers, etc.
 */
export default function PageHeader({ 
  title, 
  children,
  className = '',
}) {
  return (
    <div className={`mainHead min-h-[80px] sm:min-h-[120px] flex sm:flex-row flex-col sm:items-center p-3 sm:p-10 sm:justify-between ${className}`}>
      <div>
        <h1 className="text-lg sm:text-xl md:text-lg xl:text-xl 2xl:text-xl font-extrabold text-white sm:mt-0 mt-4">
          {title}
        </h1>
      </div>
      {children && (
        <div className="w-full sm:w-auto flex justify-end">
          {children}
        </div>
      )}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};
